export function ThumbsDown(props: any) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "80%",
        height: "80%",
        minHeight: "70px",
      }}
    >
      <svg
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ display: "block" }}
      >
        {/* Background circle - light red */}
        <rect width="70" height="70" rx="50" fill="#FEE2E2" />

        {/* Thumbs down icon centered */}
        <g transform="translate(21 23)">
          <path
            d="M7 2V12M1 9.66667V4.33333C1 3.59695 1.59695 3 2.33333 3H6.48969C6.77435 3 7.05178 2.91224 7.28531 2.74806L10.8896 0.227647C11.695 -0.326133 12.6654 -0.626153 13.6594 -0.631647L18.9999 -0.652847C20.5276 -0.661147 21.847 0.483047 22.0664 1.99095L23.2867 10.3242C23.5574 12.1539 22.1581 13.8 20.3076 13.8H16.3C15.5163 13.8 14.9333 14.5168 15.1305 15.2768L16.5199 20.7336C16.7595 21.6536 16.2904 22.6136 15.4204 23.0683C14.0704 23.7783 12.3871 23.2217 11.7304 21.8483L7.4971 12.5616C7.17643 11.8383 6.47176 11.3666 5.68843 11.3666H2.33333C1.59695 11.3666 1 10.7697 1 10.0333V9.66667Z"
            stroke="#DC2626"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    </div>
  );
}
